import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NotificationService } from 'src/core';

@Component({
  selector: 'hb-copy-button',
  template: `
    <button class="copy-button" type="button" (click)="copyToClipboard()">
      <hb-icon category="UserInterface" name="Copy" size="12"></hb-icon>
    </button>
  `,
  styleUrls: ['./copy-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyButtonComponent {
  @Input() copyContent?: string;
  @Input() notificationContent?: string;

  constructor(private readonly notificationService: NotificationService) {}

  public copyToClipboard() {
    (navigator as Navigator & { clipboard: any }).clipboard.writeText(
      this.copyContent,
    );

    if (this.notificationContent) {
      this.notificationService.showInfo({ message: this.notificationContent });
    }
  }
}
